import { Component, Input } from "@angular/core";

import { HermesCurrencyPipe } from "@hermes/aphrodite/price";
import { Product } from "@hermes/api-model-product";
import { hasVariants } from "@hermes/fragments/product-utils";
import { ProductPageFacade } from "@hermes/states/product-page";

@Component({
    selector: "h-product-info-header",
    templateUrl: "product-info-header.component.html",
    styleUrls: ["./product-info-header.component.scss"],
})
export class ProductInfoHeaderComponent {
    /** Disable price rendering for certain pages*/
    @Input()
    public showPrice: boolean = true;

    /** ecoTax extracted from product for i18n interpolation */
    public ecoTax?: string;
    public isProductRevampSelectorEnabled: boolean = false;
    public isProductPageRevampEnabled: boolean = false;

    private inputProduct!: Product;

    constructor(
        private readonly productPageFacade: ProductPageFacade,
        private readonly currencyPipe: HermesCurrencyPipe,
    ) {}

    public get product() {
        return this.inputProduct;
    }

    @Input()
    public set product(product: Product) {
        this.inputProduct = product;
        this.isProductRevampSelectorEnabled =
            this.productPageFacade.isProductRevampSelectorEnabled(product);
        this.isProductPageRevampEnabled =
            this.productPageFacade.isProductPageRevampEnabled;
        if (this.product.attributes) {
            this.ecoTax = this.product.attributes.ecoTax
                ? this.currencyPipe.transform(
                      this.product.attributes.ecoTax,
                      "full",
                  )
                : undefined;
        }
    }
    /**
     * Manage dispaly of bottom border
     */
    public shouldDisplayBorder(): boolean {
        return (
            this.product.attributes &&
            !this.product.attributes.shippingInformation &&
            !hasVariants(this.product)
        );
    }
}
